const STORAGE_KEY = 'progress';

export function getProgress() {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : {
    completedModules: [], completedSessions: [], progress: {},
  };
}

function saveProgress(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function completePart(moduleId, sessionId, partId, totalParts, totalSessions) {
  const mid = Number(moduleId);
  const sid = Number(sessionId);
  const pid = Number(partId);

  const data = getProgress();

  if (!data.progress[mid]) {
    data.progress[mid] = { sessions: {}, isCompleted: false };
  }

  if (!data.progress[mid].sessions[sid]) {
    data.progress[mid].sessions[sid] = { completedParts: [], isCompleted: false };
  }

  const session = data.progress[mid].sessions[sid];

  if (!session.completedParts.includes(pid)) {
    session.completedParts.push(pid);
  }

  if (session.completedParts.length >= totalParts) {
    session.isCompleted = true;

    const sessionKey = `${mid}/${sid}`;
    if (!data.completedSessions.includes(sessionKey)) {
      data.completedSessions.push(sessionKey);
    }
  }

  const moduleSessions = Object.values(data.progress[mid].sessions);
  if (moduleSessions.length > 0 && moduleSessions.every(s => s.isCompleted)) {
    data.progress[mid].isCompleted = true;

    if (!data.completedModules.includes(mid) && totalSessions === moduleSessions.length) {
      data.completedModules.push(mid);
    }
  }

  saveProgress(data);
}

export function isSessionCompleted(moduleId, sessionId) {
  const mid = Number(moduleId);
  const sid = Number(sessionId);
  const data = getProgress();
  return data.completedSessions.includes(`${mid}/${sid}`);
}

export function isModuleCompleted(moduleId) {
  const mid = Number(moduleId);
  const data = getProgress();
  return data.completedModules.includes(mid);
}

// Helper to retrieve completed parts for a given module/session
export function getCompletedParts(moduleId, sessionId) {
  const mid = Number(moduleId);
  const sid = Number(sessionId);
  const data = getProgress();
  const module = data.progress[mid];
  if (!module) return [];
  const session = module.sessions[sid];
  return session ? session.completedParts : [];
}

export function eraseProgress() {
  localStorage.removeItem(STORAGE_KEY);
}
